import { LabeledCheckbox } from '@/components/ui/LabeledCheckbox/LabeledCheckbox';
import { useState } from 'react';

export default function CheckboxDemo() {
  const [defaultChecked, setDefaultChecked] = useState(false);
  const [borderedChecked, setBorderedChecked] = useState(false);
  const [withSubLabel, setWithSubLabel] = useState(false);

  return (
    <div className="container mx-auto space-y-8 py-8">
      <div>
        <h1 className="mb-2 text-3xl font-bold">Checkbox Variants Demo</h1>
        <p className="text-muted-foreground">
          Exploring all variants of the LabeledCheckbox component
        </p>
      </div>

      <div className="space-y-6">
        <section className="space-y-4">
          <h2 className="text-xl font-semibold">Default Variant</h2>
          <div className="p-6">
            <LabeledCheckbox
              variant="default"
              label="Default checkbox"
              checked={defaultChecked}
              onCheckedChange={(checked) => setDefaultChecked(!!checked)}
            />
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">Bordered Variant</h2>
          <div className="p-6">
            <LabeledCheckbox
              variant="bordered"
              label="Bordered checkbox"
              checked={borderedChecked}
              onCheckedChange={(checked) => setBorderedChecked(!!checked)}
            />
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">With Sub-label</h2>
          <div className="p-6">
            <LabeledCheckbox
              variant="default"
              label="Checkbox with additional information"
              subLabel="This is a helpful description that provides more context"
              checked={withSubLabel}
              onCheckedChange={(checked) => setWithSubLabel(!!checked)}
            />
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">Disabled State</h2>
          <div className="space-y-3 p-6">
            <LabeledCheckbox
              variant="default"
              label="Disabled unchecked"
              checked={false}
              disabled
            />
            <LabeledCheckbox
              variant="default"
              label="Disabled checked"
              checked={true}
              disabled
            />
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">All Combinations</h2>
          <div className="space-y-4 p-6">
            <div className="space-y-3">
              <h3 className="text-sm font-medium">Default Variant</h3>
              <LabeledCheckbox
                variant="default"
                label="Default - Unchecked"
                checked={false}
                onCheckedChange={() => {}}
              />
              <LabeledCheckbox
                variant="default"
                label="Default - Checked"
                checked={true}
                onCheckedChange={() => {}}
              />
              <LabeledCheckbox
                variant="default"
                label="Default - With sublabel"
                subLabel="Additional context here"
                checked={false}
                onCheckedChange={() => {}}
              />
            </div>

            <div className="space-y-3">
              <h3 className="text-sm font-medium">Bordered Variant</h3>
              <LabeledCheckbox
                variant="bordered"
                label="Bordered - Unchecked"
                checked={false}
                onCheckedChange={() => {}}
              />
              <LabeledCheckbox
                variant="bordered"
                label="Bordered - Checked"
                checked={true}
                onCheckedChange={() => {}}
              />
              <LabeledCheckbox
                variant="bordered"
                label="Bordered - With sublabel"
                subLabel="Additional context here"
                checked={false}
                onCheckedChange={() => {}}
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
